import { AuthUserPermission } from '@cibo/core'
import { Can, usePermissions, useWindowTitle } from '@cibo/profile'
import { useTranslation } from 'react-i18next'
import { Navigate, generatePath, useParams } from 'react-router-dom'
import { ADMIN_ROUTES } from '../../../navigation/types'
import { Forbidden } from '../../Forbidden'
import { DataValidations } from './DataValidations'
import { ErrorReports } from './ErrorReports'
import { Offers } from './Offers'
import { SoilHealthReports } from './SoilHealthReports'

export const AgreementsOverviewRedirect = () => (
  <Navigate
    replace
    to={generatePath(ADMIN_ROUTES.AGREEMENT_TYPE_LIST, { type: 'data-validation' })}
  />
)

export const AgreementsOverview = () => {
  const { t } = useTranslation('impact/pages/Admin/AgreementsOverview')
  const { type = 'data-validation' } = useParams()
  const { can } = usePermissions()
  useWindowTitle(t('title', { context: type }))

  if (!can({ useAny: AuthUserPermission.AGREEMENTS })) {
    return <Forbidden returnTo="/" />
  }

  if (type === 'data-validation') return <DataValidations />

  if (type === 'program-offer')
    return (
      <Can
        useAny={[
          AuthUserPermission.AGREEMENTS_OFFER_READ,
          AuthUserPermission.AGREEMENTS_OFFER_WRITE,
          AuthUserPermission.AGREEMENTS_OFFER_CREATE,
        ]}
        redirectPath={generatePath(ADMIN_ROUTES.AGREEMENT_TYPE_LIST, { type: 'data-validation' })}
      >
        <Offers />
      </Can>
    )

  if (type === 'error-report') {
    return (
      <Can useAny={[AuthUserPermission.AGREEMENTS_ADMIN_REVIEW_READ]} fallback={<Forbidden />}>
        <ErrorReports />
      </Can>
    )
  }

  if (type === 'soil-health') {
    return (
      <Can
        useAny={[AuthUserPermission.AGREEMENTS_SOIL_READ, AuthUserPermission.AGREEMENTS_SOIL_WRITE]}
        fallback={<Forbidden />}
      >
        <SoilHealthReports />
      </Can>
    )
  }

  return <AgreementsOverviewRedirect />
}
